import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { BRAND } from "../../data/content";

const KEYWORDS = ["SPARTAN", "HYROX", "PRODUCER", "DJ", "OCR", "BEATS", "DISCIPLINE", "MIX & MASTER"];

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-noise" data-testid="hero-section">
      {/* hero background — REYCRO Spartan (right panel, head anchored top) */}
      <div className="absolute inset-0">
        <div className="absolute right-0 top-0 h-full w-full md:w-[60%]">
          <img
            src="https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/bdblwfoa_reycro%20spartan%20.png"
            alt="REYCRO Spartan"
            className="w-full h-full object-cover object-[center_top]"
          />
          {/* blend the panel's left edge into the black */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 md:via-black/30 to-transparent" />
        </div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/20 to-transparent md:to-black/0" />

      {/* floating neon glow blobs */}
      <div className="pointer-events-none absolute -left-32 top-1/4 w-[28rem] h-[28rem] rounded-full bg-[#BAF173] opacity-[0.12] blur-[120px]" style={{ animation: "rc-float 11s ease-in-out infinite" }} />
      <div className="pointer-events-none absolute left-1/3 -bottom-32 w-[26rem] h-[26rem] rounded-full bg-[#6735FA] opacity-[0.14] blur-[120px]" style={{ animation: "rc-float 14s ease-in-out infinite reverse" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 md:px-12 w-full pt-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="font-display text-sm sm:text-base uppercase tracking-[0.3em] text-[#11E5B4] mb-5"
        >
          {BRAND.hero}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold uppercase leading-[0.9] tracking-tighter text-white text-5xl sm:text-7xl lg:text-8xl xl:text-9xl"
        >
          Built to <span style={{ color: "var(--rc-lime)" }}>Move.</span><br />
          Wired to <span style={{ color: "var(--rc-purple)" }}>Create.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-7 max-w-xl text-base sm:text-lg text-white/70 font-medium leading-relaxed"
        >
          REYCRO — the hybrid world of Ian M. Reynaud Croda. Mexican-Italian athlete & music producer fusing sport, sound, and mentality into one culture.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-9 flex flex-col sm:flex-row gap-4"
        >
          <button data-testid="hero-partner-btn" onClick={() => go("contact")} className="font-display text-sm font-semibold uppercase tracking-widest px-8 py-4 bg-[#BAF173] text-black hover:bg-[#a5db65] hover:scale-[1.02] transition-all duration-300">
            Partner With Ian
          </button>
          <button data-testid="hero-explore-btn" onClick={() => go("about")} className="font-display text-sm font-semibold uppercase tracking-widest px-8 py-4 border border-white/25 text-white hover:border-white hover:bg-white/5 transition-all duration-300">
            Explore the Brand
          </button>
        </motion.div>
      </div>

      {/* marquee */}
      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-white/10 bg-black/40 backdrop-blur-sm py-3 overflow-hidden">
        <div className="rc-marquee flex gap-10 whitespace-nowrap w-max">
          {[...KEYWORDS, ...KEYWORDS].map((k, i) => (
            <span key={i} className="font-display text-sm uppercase tracking-[0.25em] text-white/40 flex items-center gap-10">
              {k} <span className="text-[#BAF173]">/</span>
            </span>
          ))}
        </div>
      </div>

      <button onClick={() => go("about")} className="absolute bottom-16 left-1/2 -translate-x-1/2 z-10 text-white/50 hover:text-white transition-colors hidden md:block" data-testid="hero-scroll-down">
        <ArrowDown className="animate-bounce" size={22} />
      </button>
    </section>
  );
};
